import * as tslib_1 from "tslib";
import { ElementRef, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkflowBaseDroppedField } from '../base-dropped-field.component';
var WorkflowStampSignatureFieldComponent = /** @class */ (function (_super) {
    tslib_1.__extends(WorkflowStampSignatureFieldComponent, _super);
    function WorkflowStampSignatureFieldComponent(modalService) {
        var _this = _super.call(this) || this;
        _this.modalService = modalService;
        _this.spreadFieldAllPages = new EventEmitter();
        _this.click = 2;
        return _this;
    }
    WorkflowStampSignatureFieldComponent.prototype.fieldSpread = function () {
        this.spreadFieldAllPages.emit(this.click);
    };
    WorkflowStampSignatureFieldComponent.prototype.toAction = function () {
        this.open(this.feedbackStamp, 'md');
    };
    WorkflowStampSignatureFieldComponent.prototype.open = function (content, size) {
        var _this = this;
        this.modalService
            .open(content, {
            ariaLabelledBy: 'modal-title',
            centered: true,
            keyboard: false,
            backdrop: 'static',
            size: size || 'lg'
        })
            .result.then(function (result) {
            if (result.action === 'save') {
                if (result.form === 'feedback-stamp') {
                    _this.fieldSpread();
                    return;
                }
            }
            if (result === 'cancel') {
                return;
            }
        });
    };
    return WorkflowStampSignatureFieldComponent;
}(WorkflowBaseDroppedField));
export { WorkflowStampSignatureFieldComponent };
